import { TableState } from "./table-state";

export class SearchTableState extends TableState {
    public email: string = '';
    public mobileNumber: string = '';
    public externalId: string = '';
    public siteName: string = '';
    public transactionTypeId: string = '';
    public loyaltyTransactionLogId: string ='';
    public permissionsValue: number = -1;
    public fromDate: Date;
    public toDate: Date;
    public emailCondition: number = 0;
    public mobileNumberCondition: number = 0;
    public externalIdCondition: number = 0;
    public siteNameCondition: number = 0;
    public loyaltyTransactionLogIdCondition: number = 0;
    public lastRefreshed: Date;
    public loyaltySiteId: string;
    public identifier: string;
    public tablename: string;
    public includeDisabled: boolean;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/search-table-state.ts